import {
  Box,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/** A checkbox value may arrive as the string '0'/'1' from older stored data,
 *  and the string '0' is truthy, so it must be parsed explicitly. */
function isChecked(value) {
  if (typeof value === 'boolean') return value;
  if (value === undefined || value === null || value === '') return false;
  return Boolean(parseInt(value));
}

/**
 * A bare checkbox row with an optional info tooltip on its label — for boolean
 * questions that need a sentence of explanation, without the input-sized frame
 * of the regular `checkbox` type. Stores a real boolean.
 */
const TypeInfoCheckbox = ({ field, dataCollection, updateValidationOnChange }) => {
  return (
    <FormControlLabel
      className="px-1"
      control={
        <Checkbox
          size="small"
          disabled={field.disabled}
          checked={isChecked(dataCollection[field.key])}
          onChange={(e) => updateValidationOnChange(field.key, e.target.checked)}
        />
      }
      label={
        <Box className="flex items-center gap-1">
          <Typography variant="body2">{field.label}</Typography>
          {field.tooltip && (
            <Tooltip title={field.tooltip}>
              <InfoOutlinedIcon fontSize="inherit" className="opacity-50" />
            </Tooltip>
          )}
        </Box>
      }
    />
  );
};

export default TypeInfoCheckbox;
